import React from "react";

const BRAND_IMAGES = {
  heroLandscape:
    "https://customer-assets.emergentagent.com/job_journey-freedom-live/artifacts/znvaxpw9_ChatGPT%20Image%20Jun%206%2C%202026%20at%2009_31_50%20AM.png",
  heroSquare:
    "https://customer-assets.emergentagent.com/job_journey-freedom-live/artifacts/znvaxpw9_ChatGPT%20Image%20Jun%206%2C%202026%20at%2009_31_50%20AM.png",
  hostPortraitCloseup:
    "https://customer-assets.emergentagent.com/job_journey-freedom-live/artifacts/d62is3z7_ChatGPT%20Image%20May%2010%2C%202026%20at%2010_10_36%20PM.png",
  hostPortraitElegant:
    "https://customer-assets.emergentagent.com/job_journey-freedom-live/artifacts/29aim74v_ChatGPT%20Image%20May%2010%2C%202026%20at%2010_21_48%20PM.png",
  hostPortraitAmalfi:
    "https://customer-assets.emergentagent.com/job_journey-freedom-live/artifacts/kwulmezd_ChatGPT%20Image%20May%2010%2C%202026%20at%2010_46_27%20PM.png",
};

export default BRAND_IMAGES;
